// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1377241b","453":"a70576c8","455":"a02921a8"}[chunkId] + ".chunk.js";
};